import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

export const GridWrapper = styled(Box)(({ theme }) => ({
  display: "grid",
  gap: "20px",
  width: "90%",
  margin: "0 auto",
  gridTemplateColumns: "repeat(3, 1fr)",
  [theme.breakpoints.down("lg")]: {
    gridTemplateColumns: "repeat(2, 1fr)",
  },
  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "1fr",
  },
}));

export const MarketingContainer = styled(Box)(({ theme }) => ({
  backgroundColor: "#f3f3f3",
  borderRadius: 0,
  padding: 20,
  minHeight: 380,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  transition: "all 0.3s ease",
  boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
  "&:hover": {
    transform: "translateY(-5px)",
    boxShadow: "0px 6px 14px rgba(0,0,0,0.2)",
  },
  [theme.breakpoints.down("md")]: {
    minHeight: 420,
  },
}));

export const CardTitle = styled(Typography)(({ theme }) => ({
  fontWeight: "bold",
  color: "#4a7094",
  textAlign: "center",
  marginBottom: 10,
  fontSize: 20,
  [theme.breakpoints.down("sm")]: {
    fontSize: 18,
  },
}));

export const CardDescription = styled(Typography)(() => ({
  color: "#4a7094",
  textAlign: "justify",
  lineHeight: 1.5,
}));
